import React from 'react'
import CaretUp from '@tecuity/sos-icons/react/caret-up'
import CaretDown from '@tecuity/sos-icons/react/caret-down'
import CaretLeft from '@tecuity/sos-icons/react/caret-left'
import CaretRight from '@tecuity/sos-icons/react/caret-right'
import { DATA_TYPE_EXAMPLES, LINK_EXAMPLE_DATA_TYPES } from './MiscRecordDetailUtils'

const MiscRecordDetailCard = ({
  card,
  isSelected,
  selectedFieldId,
  onCardClick,
  onFieldClick,
  onMoveFieldUp,
  onMoveFieldDown,
  onMoveCardLeft,
  onMoveCardRight,
  isFirstCard,
  isLastCard,
}) => {
  const sortedFields = [...card.Fields].sort((a, b) => a.SortOrder - b.SortOrder)

  return (
    <div className="misc-record-detail-card">
      <div
        className={`card-header${isSelected ? ' selected' : ''}`}
        role="button"
        tabIndex={0}
        onClick={() => onCardClick(card)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCardClick(card) } }}
      >
        {card.Label || '(No Label)'}
        {isSelected && (
          <div className="card-move-buttons">
            <button
              disabled={isFirstCard}
              onClick={(e) => { e.stopPropagation(); onMoveCardLeft() }}
              onKeyDown={(e) => e.stopPropagation()}
              aria-label="Move card left"
            >
              <CaretLeft />
            </button>
            <button
              disabled={isLastCard}
              onClick={(e) => { e.stopPropagation(); onMoveCardRight() }}
              onKeyDown={(e) => e.stopPropagation()}
              aria-label="Move card right"
            >
              <CaretRight />
            </button>
          </div>
        )}
      </div>
      <div className="card-fields">
        {sortedFields.map((field, index) => (
          <div
            key={`field-${field.MiscellaneousFieldId}`}
            className={`field-row${!field.IsEnabled ? ' disabled' : ''}${field.MiscellaneousFieldId === selectedFieldId ? ' selected' : ''}`}
            role="button"
            tabIndex={0}
            onClick={() => onFieldClick(field, card.CardId)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onFieldClick(field, card.CardId) } }}
          >
            <span className="field-label">{field.Label || field.DbFieldName}</span>
            <span className="field-colon">{DATA_TYPE_EXAMPLES[field.DataType] != null ? ':' : ''}</span>
            <span className={`field-example${LINK_EXAMPLE_DATA_TYPES.has(field.DataType) ? ' link-example' : ''}`}>{DATA_TYPE_EXAMPLES[field.DataType] ?? ''}</span>
            {field.MiscellaneousFieldId === selectedFieldId && (
              <div className="field-move-buttons">
                <button
                  disabled={index === 0}
                  onClick={(e) => {
                    e.stopPropagation()
                    onMoveFieldUp(index)
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  aria-label="Move field up"
                >
                  <CaretUp />
                </button>
                <button
                  disabled={index === sortedFields.length - 1}
                  onClick={(e) => {
                    e.stopPropagation()
                    onMoveFieldDown(index)
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  aria-label="Move field down"
                >
                  <CaretDown />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default MiscRecordDetailCard
